<template>
  <a-card
    hoverable
    class="recommend-card"
    :bordered="false"
    @click="$emit('click', item)"
  >
    <!-- 内容 -->
    <div class="recommend-content">
      <img :src="item.icon" class="content-icon" alt="" />

      <div class="content-title">
        {{ item.questionContent }}
      </div>
    </div>

    <!-- 底部 -->
    <div class="recommend-footer">
      <div class="tags">
        <a-tag
          style="
            border: none;
            font-weight: 400;
            font-size: 13px;
            background-color: transparent;
            color: #7d8aa0;
          "
        >
          {{ item.caseType }}
        </a-tag>
      </div>

      <a-button type="link" size="small"> 去试试 → </a-button>
    </div>
  </a-card>
</template>

<script setup>
defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
});

defineEmits(["click"]);
</script>

<style scoped lang="less">
.recommend-card {
  height: 188px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  box-shadow: 0px 5px 18px 0px rgba(35, 68, 120, 0.05);
  border-radius: 13px 13px 13px 13px;
  border: 1px solid #e2e8f2;
  transition: all 0.25s;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
  }

  /* 让Card内部成为纵向Flex布局 */
  :deep(.ant-card-body) {
    height: 100%;
    padding: 24px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
  }
}

/* 内容区域 */
.recommend-content {
  flex: 1;

  display: flex;
  align-items: flex-start;
  gap: 14px;

  overflow: hidden;
}

/* 左侧图片 */
.content-icon {
  width: 38px;
  height: 38px;
  flex-shrink: 0;
}

/* 右侧文字 */
.content-title {
  flex: 1;
  font-size: 15px;
  color: #31425e;
  line-height: 24px;
  font-weight: 500;

  /* 最多显示3行 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;

  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}

/* 底部固定 */
.recommend-footer {
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: transparent;
  padding-top: 16px;
  // border-top: 1px solid #F2F3F5;
}

/* 标签 */
.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

/* 标签样式 */
:deep(.ant-tag) {
  margin-right: 0;
  border-radius: 14px;
}

/* 查看详情按钮 */
:deep(.ant-btn-link) {
  padding: 0;
  font-size: 14px;
}
</style>
